module.exports = __webpack_public_path__ + "img/search-not-found - Branco.e7f1f180.svg";